<template>
  <AppModalEdit
    v-model="isActive"
    @clickExec="onClickExec"
    :title="title"
    exec-button-text="保存"
  >
    <WeeklySelectForm
      v-for="(day, dIndex) in days"
      :key="dIndex"
      v-model="newSettings[day.en]"
      :label="day.ja"
      :day="day.en"
      :hour-list-start="hourListStart"
      :hour-list-end="hourListEnd"
    />
  </AppModalEdit>
</template>

<script>
import uniq from 'lodash/uniq'
import WeeklySelectForm from './FormAdvancedWeeklyModalEditSelect'
export default {
  components: { WeeklySelectForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    settings: {
      // 曜日ごとに配列に整形したobject
      type: Object,
      default: () => {},
    },
    days: {
      type: Array,
      default: () => [],
    },
    useOnlyOneDay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newSettings: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      },
      hourListStart: [],
      hourListEnd: [],
    }
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    title() {
      return this.useOnlyOneDay ? '配信時間帯設定' : '配信曜日時間帯設定'
    },
  },
  watch: {
    value() {
      this.newSettings = JSON.parse(JSON.stringify(this.settings))
    },
  },
  created() {
    if (this.useOnlyOneDay) {
      this.newSettings = { schedule: [] }
    }
  },
  mounted() {
    this.initTimeList()
  },
  methods: {
    async onClickExec() {
      let result = []
      this.days.forEach(day => {
        result = result.concat(this.newSettings[day.en])
      })
      let validateResult = false
      validateResult = await this.validateLength(result)
      if (!validateResult) return
      validateResult = await this.validateStartOverEnd()
      if (!validateResult) return
      validateResult = await this.validateDuplicate()
      if (!validateResult) return
      this.$emit('change', result)
      this.isActive = false
    },
    async validateLength(result) {
      const baseMessage = `配信される時間帯が設定されていません。`
      const useWeekMessage = this.useOnlyOneDay
        ? ''
        : `配信する曜日・時間帯を設定してください。`
      if (result.length === 0) {
        await this.$confirm('入力エラー', {
          okText: '閉じる',
          onlyOk: true,
          body: `${baseMessage}\n${useWeekMessage}`,
        })
        return false
      }
      return true
    },
    async validateDuplicate() {
      let result = []
      let usedHour = []
      this.days.forEach(day => {
        usedHour = []
        // 単数の設定or配信停止ならエラーにならない
        if (this.newSettings[day.en].length < 2) return
        this.newSettings[day.en].forEach(range => {
          for (let i = range.startHour; i <= range.endHour; i++) {
            if (usedHour.indexOf(i) >= 0) {
              result.push(day.ja)
              return
            }
            usedHour.push(i)
          }
        })
      })

      result = uniq(result)

      if (result.length !== 0) {
        await this.$confirm('入力エラー', {
          okText: '閉じる',
          onlyOk: true,
          body:
            result.join('と') +
            'に設定している配信時間帯が重複しています。\n重複しないように設定を変更してください。',
        })
        return false
      }
      return true
    },
    async validateStartOverEnd() {
      let result = []
      this.days.forEach(day => {
        this.newSettings[day.en].forEach(range => {
          if (range.startHour > range.endHour) {
            result.push(day.ja)
            return
          }
        })
      })
      if (result.length !== 0) {
        await this.$confirm('入力エラー', {
          okText: '閉じる',
          onlyOk: true,
          body:
            result.join('と') +
            'に設定している配信時間帯の開始時刻が終了時刻より後になっています。\n正しい値を設定してください。',
        })
        return false
      }
      return true
    },
    initTimeList() {
      const tempListStart = []
      const tempListEnd = []
      for (let i = 0; i <= 23; i++) {
        tempListStart.push({
          text: this.zeroPadding(i) + ':00',
          value: i,
        })
        tempListEnd.push({
          text: this.zeroPadding(i) + ':59',
          value: i,
        })
      }
      this.hourListStart = tempListStart
      this.hourListEnd = tempListEnd
    },
    zeroPadding(num, length = 2) {
      return ('0' + num).slice(-length)
    },
  },
}
</script>

<style></style>
